/* Cart drawer (88), sections/cart-drawer-88.liquid + snippets/cart-drawer-88-*.
   Horizon owns the drawer: <theme-drawer id="cart-drawer"> opens/closes it (Esc, backdrop, focus
   trap, focus return) and <cart-items-component> morphs the section in after every cart change.
   This element only turns clicks into Ajax Cart API calls. Each call asks for this section's HTML
   (?sections=) and is announced with Horizon's CartLinesUpdateEvent, resolved with that HTML, so
   Horizon re-renders the drawer and the header cart bubble from one response. No legacy hooks,
   no global form interception: Horizon's product forms and Shopify.actions already open this drawer. */
(function () {
  'use strict';
  if (customElements.get('cart-drawer-88')) return;

  var eventsModule = null;
  function getEvents() {
    if (!eventsModule) {
      eventsModule = import('@shopify/events')
        .then(function (m) { return m && m.CartLinesUpdateEvent && m.CartLinesUpdateEvent.createPromise ? m.CartLinesUpdateEvent : null; })
        .catch(function () { return null; });
    }
    return eventsModule;
  }

  function postJSON(url, payload) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Hmm, that didn’t work. Try again in a moment.');
        return data;
      });
    });
  }

  class CartDrawer88 extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.noteTimer = null;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
    }

    get sectionId() { return this.dataset.sectionId; }

    /* One cart change: POST, hand the rendered section to Horizon, then tidy focus + announce. */
    request(urlKey, payload, action, message) {
      var self = this;
      var url = this.dataset[urlKey];
      var sectionId = this.sectionId;
      var cartUrl = this.dataset.cartUrl;
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
      var scroller = this.querySelector('.cd88__scroll');
      var scrollTop = scroller ? scroller.scrollTop : 0;
      this.classList.add('is-busy');

      return getEvents().then(function (Ev) {
        var deferred = Ev ? Ev.createPromise() : null;
        if (Ev) self.dispatchEvent(new Ev({ action: action, context: 'cart', lines: [], promise: deferred.promise }));

        return postJSON(url, payload)
          .then(function (data) {
            /* change.js and update.js answer with the cart; add.js only with the added items */
            var cartPromise = typeof data.item_count === 'number'
              ? Promise.resolve(data)
              : fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
            return cartPromise.then(function (cart) {
              var sections = data.sections || {};
              if (deferred) {
                deferred.resolve({
                  cart: Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : cart,
                  detail: { sections: sections, items: cart.items, itemCount: cart.item_count, source: 'cart-drawer-88', didError: false }
                });
              } else if (sections[sectionId]) {
                self.renderFallback(sections[sectionId]);
              }
            });
          })
          .catch(function (err) {
            if (deferred) deferred.reject(err);
            self.showError(err && err.message);
            self.refresh();
          });
      }).then(function () {
        /* Horizon morphs on the same promise; let it finish first */
        setTimeout(function () {
          var root = document.querySelector('cart-drawer-88') || self;
          root.classList.remove('is-busy');
          var sc = root.querySelector('.cd88__scroll');
          if (sc) sc.scrollTop = scrollTop;
          var active = document.activeElement;
          if (!active || active === document.body || !root.contains(active)) {
            var close = root.querySelector('[data-cd88-close]');
            if (close) close.focus({ preventScroll: true });
          }
          if (message) root.announce(message);
        }, 60);
      });
    }

    /* After an error: re-render from the server so the drawer matches the real cart */
    refresh() {
      var sectionId = this.sectionId;
      return import('@theme/section-renderer')
        .then(function (m) { return m.sectionRenderer.renderSection(sectionId, { cache: false, mode: 'hydration' }); })
        .catch(function () {});
    }

    /* Only used if Horizon's event module can't load */
    renderFallback(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
      var inner = this.closest('[data-hydration-key="cart-drawer-inner"]');
      if (fresh && inner) { inner.className = fresh.className; inner.innerHTML = fresh.innerHTML; }
    }

    showError(text) {
      var el = this.querySelector('[data-cd88-error]');
      if (!el) return;
      el.textContent = text || 'Hmm, that didn’t work. Try again in a moment.';
      el.hidden = false;
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(function () { el.hidden = true; }, 6000);
    }

    announce(text) {
      var el = this.querySelector('[data-cd88-status]');
      if (!el) return;
      el.textContent = '';
      setTimeout(function () { el.textContent = text; }, 50);
    }

    onClick(e) {
      var t = e.target;
      if (t.closest('[data-cd88-close]')) {
        e.preventDefault();
        var drawer = this.closest('theme-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        return;
      }

      var qty = t.closest('[data-cd88-qty]');
      if (qty) {
        var q = Math.max(0, parseInt(qty.getAttribute('data-value'), 10) || 0);
        this.request('changeUrl', { line: parseInt(qty.getAttribute('data-cd88-qty'), 10), quantity: q }, q === 0 ? 'remove' : 'update', q === 0 ? 'Item removed' : 'Quantity updated');
        return;
      }

      var sub = t.closest('[data-cd88-subscribe]');
      if (sub) {
        this.request('changeUrl', {
          line: parseInt(sub.getAttribute('data-cd88-subscribe'), 10),
          quantity: parseInt(sub.getAttribute('data-qty'), 10) || 1,
          selling_plan: parseInt(sub.getAttribute('data-plan'), 10)
        }, 'update', 'Switched to Subscribe & Save');
        return;
      }

      var add = t.closest('[data-cd88-add]');
      if (add) {
        var item = { id: parseInt(add.getAttribute('data-cd88-add'), 10), quantity: 1 };
        var plan = add.getAttribute('data-plan');
        if (plan) item.selling_plan = parseInt(plan, 10);
        this.request('addUrl', { items: [item] }, 'add', 'Added to cart');
        return;
      }

      var toggle = t.closest('[data-cd88-gift-toggle]');
      if (toggle) {
        var gift = toggle.closest('[data-cd88-gift]');
        var open = !gift.hasAttribute('data-open');
        gift.toggleAttribute('data-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var ta = gift.querySelector('textarea'); if (ta) ta.focus(); }
        return;
      }

      var checkout = t.closest('[data-cd88-checkout]');
      if (checkout) {
        /* save the latest gift message before leaving */
        var note = this.querySelector('[data-cd88-note]');
        if (note && this.noteTimer) {
          e.preventDefault();
          clearTimeout(this.noteTimer);
          this.noteTimer = null;
          this.saveNote(note.value).then(function () { window.location.href = checkout.href; });
        }
      }
    }

    onChange(e) {
      var sel = e.target.closest('[data-cd88-plan]');
      if (!sel) return;
      this.request('changeUrl', {
        line: parseInt(sel.getAttribute('data-cd88-plan'), 10),
        quantity: parseInt(sel.getAttribute('data-qty'), 10) || 1,
        selling_plan: parseInt(sel.value, 10)
      }, 'update', 'Delivery frequency updated');
    }

    onInput(e) {
      var note = e.target.closest('[data-cd88-note]');
      if (!note) return;
      clearTimeout(this.noteTimer);
      this.noteTimer = setTimeout(() => { this.noteTimer = null; this.saveNote(note.value); }, 500);
    }

    saveNote(value) {
      return postJSON(this.dataset.updateUrl, { note: value }).catch(function () {});
    }
  }

  customElements.define('cart-drawer-88', CartDrawer88);
})();
